var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5901_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75002 16.5C15.136 16.5 19.5 12.8062 19.5 8.25C19.5 3.69375 15.136 0 9.75002 0C4.36409 0 2.47395e-05 3.69375 2.47395e-05 8.25C2.47395e-05 10.0594 0.689087 11.7328 1.85627 13.0969C1.69221 13.5375 1.44846 13.9266 1.19065 14.2547C0.96565 14.5453 0.735962 14.7703 0.567212 14.925C0.482837 15 0.412525 15.0609 0.36565 15.0984C0.342212 15.1172 0.323462 15.1312 0.314087 15.1359L0.304712 15.1453C0.0468997 15.3375 -0.0656003 15.675 0.0375247 15.9797C0.14065 16.2844 0.426587 16.5 0.750025 16.5C1.7719 16.5 2.80315 16.2375 3.66096 15.9141C4.09221 15.75 4.49534 15.5672 4.8469 15.3797C6.28596 16.0922 7.9594 16.5 9.75002 16.5ZM21 8.25C21 13.5141 16.3547 17.4797 10.8516 17.9531C11.9906 21.4406 15.7688 24 20.25 24C22.0406 24 23.7141 23.5922 25.1578 22.8797C25.5094 23.0672 25.9078 23.25 26.3391 23.4141C27.1969 23.7375 28.2281 24 29.25 24C29.5735 24 29.8641 23.7891 29.9625 23.4797C30.061 23.1703 29.9531 22.8328 29.6907 22.6406L29.6813 22.6312C29.6719 22.6219 29.6531 22.6125 29.6297 22.5938C29.5828 22.5562 29.5125 22.5 29.4281 22.4203C29.2594 22.2656 29.0297 22.0406 28.8047 21.75C28.5469 21.4219 28.3031 21.0281 28.1391 20.5922C29.3063 19.2328 29.9953 17.5594 29.9953 15.7453C29.9953 11.3953 26.0156 7.82812 20.9672 7.51875C20.986 7.75781 20.9953 8.00156 20.9953 8.24531L21 8.25Z",
    fill: "#3366FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5901_140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4e46452da62de9015ae15f0bd9a85366.svg";
export { ForwardRef as ReactComponent };